module.exports = __webpack_public_path__ + "static/media/loader.7ba725da.gif";